import { Box, Typography } from '@mui/material';
import ChatResource, {
  ChatData,
  ParsedScore,
} from '../../resources/ChatResource';
import ScoreCard from './ScoreCard';

interface Props {
  chat: ChatData;
}

function extractData(chat: ChatData): {
  summary: string;
  scores: ParsedScore[];
} {
  const summary = chat.feedbacks.find(
    (feedback) => feedback.type === 'summary' && feedback.section === 'fulltest'
  );

  return {
    summary: summary?.content || summary?.contentJp || '',
    scores: ChatResource.parseScores(
      ['arousal', 'valence', 'eyeContact'],
      chat,
      'fulltest',
      3
    ),
  };
}

export default function FullTestTab({ chat }: Props) {
  const { summary, scores } = extractData(chat);

  return (
    <Box className="flex flex-col gap-8">
      <Box className="flex flex-col gap-4">
        <Typography variant="h2">Summary</Typography>
        <Typography variant="body1" whiteSpace="break-spaces">
          {summary}
        </Typography>
      </Box>
      <Box className="flex flex-col gap-4">
        <Typography variant="h2">Scores (Communication)</Typography>
        <Box className="grid grid-cols-2 gap-4">
          {scores.map((score) => (
            <ScoreCard key={score.label} score={score} showPassFail />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
